<div class="button-menu">
  <app-button-menu-item
    *ngFor="let status of gallery.enabled_gallery_statuses | galleryStatusOrder"
    name="gallery-status-{{ status }}"
    [icon]="status | galleryStatusIcon"
    location="gallery-status-context"
    [attr.data-test-id]="'gallery-status-' + status"
    [color]="gallery.status === status ? (status | galleryStatusButtonColor) : 'simple'"
    [weight]="gallery.status === status ? 'bold' : undefined"
    (click)="onSelectStatus.emit(status)"
    [iconColor]="status | galleryStatusColor"
    [fullWidth]="true"
  >
    <div class="gallery-status-option">
      <span>{{ status | galleryStatusName }}</span>
      <app-svg src="/assets/icons/checkmark.svg" color="primary" *ngIf="gallery.status === status"></app-svg>
    </div>
  </app-button-menu-item>
</div>
